import config from '../../assets/js/conf/config'
import request from '../../assets/js/utils/request'

const base = config.baseApi + '/merchant/wechat-shop'

export const getWechatCategoryCatalog = (params) => request.get(base + '/category-applications/catalog', params)
export const preflightWechatCategory = (data) => request.post(base + '/category-applications/preflight', data)
export const createWechatCategoryBatch = (data) => request.postJson(base + '/category-application-batches', data)
export const getWechatCategoryBatch = (id) => request.get(base + '/category-application-batches/' + id)
export const getWechatCategoryApplications = (params) => request.get(base + '/category-applications', params)
export const retryWechatCategoryApplications = (data) => request.post(base + '/category-applications/retry', data)
export const getWechatEffectiveCategories = (params) => request.get(base + '/effective-categories', params)
export const syncWechatCategoryCatalog = (data) => request.post(base + '/category-applications/sync-catalog', data)
export const getWechatCategoryCatalogSyncStatus = (params) => request.get(base + '/category-applications/sync-catalog/status', params)
export const syncWechatEffectiveCategories = (data) => request.post(base + '/effective-categories/sync', data)
